import React from 'react';
import * as PropTypes from 'prop-types';

import { redirectToHealthBoard } from '../../../utils/appointments/redirect-utils';
import Popup from '../../common/Popup';
import Button from '../../Button';

import styles from './styles.styl';

function CompleteInlineVisitModal({ isOpened, formatMessage, userId }) {
  return (
    <Popup
      opened={isOpened}
      withHeading={false}
      mobileFullScreen={false}
      width="rubber"
      contentNoPadding
    >
      <div className={styles.root}>
        <div className={styles.title}>
          {formatMessage({
            id: 'appointment.inlineVisit.success.inLine.title',
          })}
        </div>
        <div className={styles.message}>
          {formatMessage({
            id: 'appointment.inlineVisit.success.inLine.description',
          })}
        </div>
        <Button
          raised
          color="primary"
          className={styles.button}
          onClick={() => redirectToHealthBoard(userId)}
        >
          {formatMessage({ id: 'common.complete' })}
        </Button>
      </div>
    </Popup>
  );
}

CompleteInlineVisitModal.propTypes = {
  isOpened: PropTypes.bool,
  formatMessage: PropTypes.func,
  userId: PropTypes.number,
};

export default CompleteInlineVisitModal;



// WEBPACK FOOTER //
// ./src/components/AppointmentForm/CompleteInlineVisitModal/index.jsx